import React, {Component} from 'react';

const LoadingAnimation = (props) =>
    <div style={{display: 'flex', justifyContent: 'center'}}>
        <img src="images/orig.gif"/>
    </div>

export default LoadingAnimation;


// WEBPACK FOOTER //
// ./src/components/loading-animation.js